import { render, staticRenderFns } from "./GridFields.vue?vue&type=template&id=3884c3b5"
import script from "./GridFields.vue?vue&type=script&lang=js"
export * from "./GridFields.vue?vue&type=script&lang=js"
import style0 from "./GridFields.vue?vue&type=style&index=0&id=3884c3b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports